import { escapeStringRegexp, umlautMap } from '@utils/helpers';

const replaceUmlaute = (str: string) => {
  if (!str || typeof str !== 'string') {
    return '';
  }

  return str
    .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
      const big = umlautMap[a.slice(0, 1)];
      return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
    })
    .replace(new RegExp(`[${Object.keys(umlautMap).join('|')}]`, 'g'), (a) => umlautMap[a]);
};

export const filterCol = (doc: any, filterInfo: any) => {
  const filterText = filterInfo.text?.[0] ?? false;
  if (!filterText) {
    return true;
  }

  const filterRegex = new RegExp(escapeStringRegexp(replaceUmlaute(filterText)), 'i');
  let result = false;

  for (const key of ['date', 'header', 'text', 'doctypeheader']) {
    if (result) {
      break;
    }

    const fieldValue = doc[key];

    if (filterRegex.test(replaceUmlaute(fieldValue))) {
      result = true;
    }
  }

  return result;
};

export const filterColByDetailField = (doc: any, searchFields: any, fieldKey: string) => {
  if (!searchFields || !searchFields[fieldKey] || !searchFields[fieldKey].filterVals.length) {
    return true;
  }

  return replaceUmlaute(searchFields[fieldKey].filterVals).indexOf(replaceUmlaute(doc[fieldKey])) > -1;
};

export const groupDocumentsByYear = (documents: Array<any>): { [key: string]: any[] } =>
  documents.reduce<any>((prev, fileLinkNode) => {
    const fileLink = fileLinkNode;
    const year = Number.parseInt(fileLink.year, 10);

    if (prev[year] !== undefined) {
      prev[year].push(fileLink);
    } else {
      prev[year] = [fileLink];
    }
    return prev;
  }, {});
